
import { ClientModalNames } from "./client-modal-name";
import ClientUserCreate from "../page/components/client-modal-create";
import { ClientControllerState, ClientControllerAction } from "../controller/client-controller";
import ClientUserUpdate from "../page/components/client-modal-update";
import ClientUserInfo from "../page/components/client-modal-info";
import { CustomAlertAction, CustomAlertState } from "../../../alert/controller/custom.alert.controller";

export interface ClientChildrenModel {
    name: ClientModalNames;
    child: ({ ctrl, alert }: { ctrl: ClientControllerState & ClientControllerAction, alert: CustomAlertAction & CustomAlertState }) => JSX.Element,
}
export const ClientModalChildrenData: ClientChildrenModel[] = [
    {
        name: ClientModalNames.CREATE,
        child: ({ ctrl }: { ctrl: ClientControllerState & ClientControllerAction }) => <ClientUserCreate ctrl={ctrl} />,
    },
    {
        name: ClientModalNames.UPDATE,
        child: ({ ctrl }: { ctrl: ClientControllerState & ClientControllerAction }) => <ClientUserUpdate ctrl={ctrl} />,

    },
    {
        name: ClientModalNames.INFO,
        child: ({ ctrl, alert }: { ctrl: ClientControllerState & ClientControllerAction, alert: CustomAlertAction & CustomAlertState }) => <ClientUserInfo alert={alert} ctrl={ctrl} />,

    }
]